const styles = {
  form: {
    display: 'inline-block',
    width: '250px',
    verticalAlign: 'top',
  },
};

export default styles;
